module.exports = __webpack_public_path__ + "img/53af59f.jpg";